export const DEFAULT_GENERATE_TIMEOUT = 60000;
export const AI_FEATURE_CONVERSATION_SUMMARIZATION = 'AIGroup.ConversationSummarization';
export const AI_FEATURE_UTTERANCE_GENERATION = 'AIGroup.UtteranceGeneration';
export const AI_FEATURE_GENERATIVE_QUESTION_ANSWERING = 'AIGroup.GenerativeQuestionAnswering';
export const AI_FEATURE_LIVECHAT_SUMMARIZATION = 'AIGroup.LiveChatSummarization';
export const AI_FEATURE_TEXT_RESPONSE_GENERATION = 'AIGroup.TextResponseGeneration';
export const AI_FEATURE_PROJECT_GENERATION = 'AIGroup.ProjectGeneration';
export const AI_FEATURE_GENERATIVE_CODING_ASSISTANT = 'AIGroup.GenerativeCodingAssistant';
